export default "__VITE_ASSET__BJXeSMVF__"